import React from 'react'

const JoyrideSubtitle = ({ children, ...props }) => (
  <p className="text-color-09242f text-size-16px font-weight-400 leading-none whitespace-pre-wrap" {...props}>
    {children}
  </p>
)

export default JoyrideSubtitle
